import React from 'react';
import { Card, CardBody, CardHeader, Spinner, Badge } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

const TARGET_TYPE_LABELS = (t) => ({
  WORK_ORDER: t('shared.target_type_work_order', 'Work Order'),
  SERVICE_REQUEST: t('shared.target_type_service_request', 'Service Request'),
  ASSET: t('shared.target_type_asset', 'Asset'),
});

const TARGET_TYPE_COLORS = {
  WORK_ORDER: 'primary',
  SERVICE_REQUEST: 'info',
  ASSET: 'warning',
};

const EscalationEventsWidget = ({ events, loading }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h3 className="card-title text-success mb-0">
          <AlertTriangle size={18} className="me-2" />
          {t('escalation.events', 'Escalation Events')}
        </h3>
      </CardHeader>
      <CardBody>
        {loading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : !events?.content?.length ? (
          <div className="text-center py-5 text-muted">
            <p>{t('escalation.no_events', 'No escalation events recorded yet.')}</p>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th>{t('shared.date', 'Date')}</th>
                  <th>{t('escalation.policy_name', 'Policy')}</th>
                  <th>{t('escalation.level', 'Level')}</th>
                  <th>{t('escalation.target', 'Target')}</th>
                  <th>{t('escalation.notified', 'Notified')}</th>
                  <th>{t('shared.status', 'Status')}</th>
                </tr>
              </thead>
              <tbody>
                {events.content.map((event) => (
                  <tr key={event.id}>
                    <td className="small">
                      {new Date(event.triggeredAt).toLocaleDateString('en-GB')}
                      {' '}
                      {new Date(event.triggeredAt).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                    </td>
                    <td>{event.policyName}</td>
                    <td>
                      <Badge color={event.levelOrder >= 3 ? 'danger' : event.levelOrder === 2 ? 'warning' : 'info'}>
                        L{event.levelOrder}
                      </Badge>
                    </td>
                    <td>
                      <Badge color={TARGET_TYPE_COLORS[event.targetType] || 'secondary'} className="me-1">
                        {TARGET_TYPE_LABELS(t)[event.targetType]?.split(' ')[0]}
                      </Badge>
                      {event.targetReference}
                    </td>
                    <td className="small">
                      {event.notifiedUsers?.map(u => u.name).join(', ')}
                    </td>
                    <td>
                      <Badge color={event.cancelled ? 'secondary' : 'success'}>
                        {event.cancelled ? t('escalation.cancelled', 'Cancelled') : t('escalation.active', 'Active')}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default EscalationEventsWidget;
